/**
 * Haelt die klebende Bildspalte der Produktseite senkrecht in der Mitte des
 * Fensters.
 *
 * In CSS geht das nicht: der Klebeabstand braucht einen festen Wert, die
 * Bildhoehe haengt aber vom Seitenverhaeltnis des Produktbildes und von der
 * Fensterbreite ab. Deshalb wird der Abstand hier gerechnet und als
 * Inline-Wert gesetzt; er schlaegt die feste Vorgabe aus dem Stylesheet, die
 * als Rueckfallebene stehen bleibt.
 *
 * Unter 1068 Pixeln stehen die Spalten untereinander, dort klebt nichts.
 */
(function () {
  'use strict';

  var MINDESTABSTAND = 20;
  var galerie = null;

  function setzen() {
    if (!galerie) return;

    if (window.innerWidth < 1068) {
      galerie.style.top = '';
      return;
    }

    var frei = window.innerHeight - galerie.offsetHeight;
    // Ist das Bild hoeher als das Fenster, bleibt es oben stehen, sonst waere
    // sein Kopf nicht mehr zu sehen.
    var oben = frei > 0 ? Math.round(frei / 2) : MINDESTABSTAND;
    galerie.style.top = Math.max(MINDESTABSTAND, oben) + 'px';
  }

  function start() {
    galerie = document.querySelector('.product-gallery-sticky');
    if (!galerie) return;
    setzen();

    window.addEventListener('resize', setzen, { passive: true });

    // Die Hoehe steht erst fest, wenn das Bild geladen ist, und sie aendert
    // sich beim Variantenwechsel.
    if (window.ResizeObserver) {
      new ResizeObserver(setzen).observe(galerie);
    } else {
      window.addEventListener('load', setzen);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
